import { Box, Typography } from "@mui/material";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc"; // ES 2015
import timezone from "dayjs/plugin/timezone"; // ES 2015
import isoWeek from "dayjs/plugin/isoWeek"; // ES 2015
import getAvatarColor from "../../../../helper/getAvatarColor";
import { getWorkStationColor } from "../../../../helper/workStationHelper";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(isoWeek);
const DEFAULT_TIMEZONE = "America/Phoenix";
dayjs.tz.setDefault(DEFAULT_TIMEZONE);

const WorkStationTypes = [
  "Shear",
  "Brake",
  "Slit Line",
  "Roll Former",
  "Bench",
  "Laser",
];

const ShopCalendarEvent = ({ calendarEvent, onClick }) => {
  let { title } = calendarEvent;
  return (
    <Box
      sx={{
        flex: 1,
        // background: getAvatarColor(calendarEvent.assignedTo.id),
        display: "flex",
        flexDirection: "row",
      }}
      onClick={onClick}
    >
      <Box sx={{ marginLeft: "8px", flex: 1 }}>
        <Typography sx={{ overflow: "hidden", fontSize: "12px" }}>
          {title} -{" "}
          {dayjs(calendarEvent.startDate).tz(DEFAULT_TIMEZONE).format("h:mm a")}{" "}
          to{" "}
          {dayjs(calendarEvent.endDate).tz(DEFAULT_TIMEZONE).format("h:mm a")}
        </Typography>
      </Box>
    </Box>
  );
};

export default ShopCalendarEvent;
